module.exports = __webpack_public_path__ + "static/media/bdlogo.80ce7d61.webp";